export const ENABLE_VB_ERROR_TOAST_MESSAGE =
  'Please enable virtual backgrounds.'
export const ENABLE_CAMERA_ERROR_TOAST_MESSAGE =
  'Start your video to set background.'
export const DOWNLOAD_VB_PACKAGE =
  'To set a virtual background, download a virtual background package. Click “Choose Virtual Backgrounds” in the video menu and set a background to download.'
export const DEFAULT_ERROR_TOAST_MESSAGE = 'An error occured.'
export const SET_BACKGROUND_SUCCESS = 'Successfully set background'
export const SET_BACKGROUND_FAILURE =
  'Was unable to set background, please try again'
export const REMOVE_BACKGROUND_SUCCESS = 'Successfully removed background'
export const REMOVE_BACKGROUND_FAILURE =
  'Was unable to remove background, please try again'
export const BLUR_BACKGROUND_SUCCESS = 'Successfully blurred background'
export const BLUR_BACKGROUND_FAILURE =
  'Was unable to blur background, please try again'
export const CONSENT_REJECTION_ERROR = 'You denied the request.'
export const VB_IMAGE_TYPES = {
  none: 'none',
  blur: 'blur',
}
